import type { TypePolicies } from '@apollo/client';

// Disable cache normalization for IdentityTeam. The API can return different
// brokerage data for the same team ID depending on the agent being queried,
// so normalizing by ID causes one agent's brokerage to overwrite another's.
export const IdentityTeam: TypePolicies['IdentityTeam'] = {
  keyFields: false,
};
